// Helpers partagés pour les exports Excel (ExcelJS)
import logoCapUrl from '../../assets/logo/logo-cap-assurances.JPG';

let _logoBuffer = null;

// Charge (et met en cache) le logo CAP Assurances (ArrayBuffer).
async function getLogoBuffer() {
    if (_logoBuffer) return _logoBuffer;
    const resp = await fetch(logoCapUrl);
    const blob = await resp.blob();
    _logoBuffer = await blob.arrayBuffer();
    return _logoBuffer;
}

// Insère le logo CAP (flottant, haut-gauche) puis 3 lignes vides
// pour lui réserver une bande d'en-tête. À appeler juste après
// `ws.columns = ...` et AVANT la ligne de titre. Non bloquant.
export async function addExcelLogoHeader(wb, ws) {
    try {
        const buffer = await getLogoBuffer();
        const imageId = wb.addImage({ buffer, extension: 'jpeg' });
        ws.addImage(imageId, { tl: { col: 0, row: 0 }, ext: { width: 170, height: 62 } });
    } catch {
        /* logo non bloquant */
    }
    ws.addRow([]);
    ws.addRow([]);
    ws.addRow([]);
}

// Ajoute une ligne centrée « Exporté le … | Exporté par : … » fusionnée
// sur `colCount` colonnes. À placer dans le bloc méta (avant l'en-tête).
export function addExcelExportInfo(ws, { colCount, exporterName, today }) {
    const date = today || new Date().toLocaleDateString('fr-FR');
    const text = exporterName
        ? `Exporté le ${date}   |   Exporté par : ${exporterName}`
        : `Exporté le ${date}`;
    const row = ws.addRow([text]);
    ws.mergeCells(row.number, 1, row.number, colCount);
    row.getCell(1).font = { italic: true, size: 10, color: { argb: '666666' } };
    row.getCell(1).alignment = { horizontal: 'center' };
    return row;
}

export const EXCEL_THIN_BORDER = {
    top: { style: 'thin' },
    bottom: { style: 'thin' },
    left: { style: 'thin' },
    right: { style: 'thin' },
};

// Convertit une valeur (nombre ou chaîne formatée "120 000") en nombre.
const toNumber = (v) => {
    if (typeof v === 'number') return v;
    const n = Number(String(v ?? '').replace(/[^\d-]/g, ''));
    return Number.isFinite(n) ? n : 0;
};

// Aligne à droite + format milliers les colonnes monétaires (indices 0-based)
// et ajoute une ligne TOTAL (somme par colonne). À appeler AVANT borderExcelTable
// pour que la ligne TOTAL soit aussi tracée.
export function addExcelTotals(ws, { headerRow, numericCols = [], labelCol = 1 }) {
    if (!ws || !headerRow || !numericCols.length) return null;
    const cols1 = numericCols.map((c) => c + 1); // 0-based -> 1-based
    const firstData = headerRow + 1;
    const lastData = ws.rowCount;
    const sums = {};
    cols1.forEach((c) => { sums[c] = 0; });

    for (let r = firstData; r <= lastData; r += 1) {
        const row = ws.getRow(r);
        cols1.forEach((c) => {
            const cell = row.getCell(c);
            const num = toNumber(cell.value);
            cell.value = num;
            cell.numFmt = '#,##0';
            cell.alignment = { ...(cell.alignment || {}), horizontal: 'right' };
            sums[c] += num;
        });
    }

    const totalRow = ws.addRow([]);
    const lab = totalRow.getCell(labelCol);
    lab.value = 'TOTAL';
    lab.font = { bold: true };
    lab.alignment = { horizontal: 'right' };
    cols1.forEach((c) => {
        const cell = totalRow.getCell(c);
        cell.value = sums[c];
        cell.numFmt = '#,##0';
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'right' };
    });
    return totalRow;
}

// Trace toutes les cellules du tableau (en-tête + données + total) :
// de la ligne `fromRow` jusqu'à la dernière ligne, sur `colCount` colonnes.
export function borderExcelTable(ws, fromRow, colCount) {
    if (!ws || !fromRow || !colCount) return;
    const last = ws.rowCount;
    for (let r = fromRow; r <= last; r += 1) {
        const row = ws.getRow(r);
        for (let c = 1; c <= colCount; c += 1) {
            row.getCell(c).border = EXCEL_THIN_BORDER;
        }
    }
}
